import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type OriginalMediaInfoFragment = { __typename?: 'OriginalInfo', key: string, downloadUrl?: string | null, filesizeInBytes?: number | null, inlineUrl?: string | null, codec?: string | null };

export const OriginalMediaInfo = /*#__PURE__*/ gql`
    fragment OriginalMediaInfo on OriginalInfo {
  key
  downloadUrl
  filesizeInBytes
  inlineUrl
  codec
}
    ` as unknown as DocumentNode<OriginalMediaInfoFragment, unknown>;

        

        
export const useOriginalMediaInfoFragment = (
  input: string | Omit<UseFragmentOptions<OriginalMediaInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'OriginalInfo' } };
    return input;
  })();

  return useFragment<OriginalMediaInfoFragment>({
    fragment: OriginalMediaInfo,
    fragmentName: 'OriginalMediaInfo',
    ...options,
  });
};
  
        